export default {
    title: "Central de benefícios",
    loadError: "Não foi possível carregar a central de benefícios.",
    saveError: "Não foi possível salvar a central de benefícios.",
    saveSuccess: "Configurações salvas com sucesso.",
    preview: {
        title: "Pré-visualização",
        placeholder: "Espaço reservado para o preview",
        screenLogin: "Login",
        screenApp: "App",
        link: "Link de acesso",
        linkCopied: "Link copiado",
        open: "Ver preview",
        close: "Fechar preview",
        viewAs: "Ver como",
        viewAsPlaceholder: "Cliente sem nível",
    },
    tabs: {
        label: "Seções da central de benefícios",
        settings: "Configurações",
        tiers: "Níveis",
        points: "Programa de pontos",
        referrals: "Indicação",
        cashback: "Cashback",
        empty: "Esta seção será configurada nas próximas etapas.",
        comingSoon: "Em breve",
    },
    settings: {
        clubName: "Nome do Club",
        clubNameRequired: "O nome do clube é obrigatório.",
        logo: "Logo",
        logoUploadTitle: "Escolha uma imagem ou arraste e solte aqui.",
        logoUploadDescription: "Use uma imagem em .jpg ou .png",
        logoUploadButton: "Procurar imagem",
        logoUploadDelete: "Remover logo",
        font: "Fonte",
        color: "Cor",
        defaultFont: "Padrão",
        advanced: "Configurações avançadas",
        showStatement: "Exibir extrato",
        customCss: "CSS personalizado",
    },
    tiers: {
        systemLabel: "Sistema de níveis",
        title: "Níveis",
        emptyTitle: "Crie seu sistema de níveis",
        emptyDescription: "Crie níveis e ofereça recompensas exclusivas para aumentar o engajamento e a frequência de compra dos seus clientes.",
        createFirst: "Criar primeiro nível",
        addLevel: "Adicionar nível",
        disabledNotice: "Sistema de níveis desligado: seus clientes não veem os níveis.",
        pointsDisabledNotice: "Ligue o programa de pontos para usar os níveis.",
        dragHandle: "Arrastar para reordenar",
        becomingTitle: "Como ser {name}?",
        createSuccess: "Nível criado com sucesso.",
        editSuccess: "Nível salvo com sucesso.",
        createError: "Não foi possível criar o nível.",
        editError: "Não foi possível salvar o nível.",
        deleteSuccess: "Nível excluído com sucesso.",
        deleteError: "Não foi possível excluir o nível.",
        reorderError: "Não foi possível salvar a nova ordem dos níveis.",
        errors: {
            segmentNotFound: "O segmento escolhido não existe mais. Escolha outro segmento.",
            segmentInUse: "Esse segmento já é usado pelo nível {tierName}.",
            tierNameTaken: "Já existe um nível com esse nome.",
            tierNotFound: "Esse nível não existe mais. Recarregue a página.",
            nameTooLong: "O nome do nível pode ter até 100 caracteres.",
            descriptionTooLong: "A descrição está grande demais. Encurte o texto e tente de novo.",
            becomingDescriptionTooLong: "O texto de \"Como se tornar\" está grande demais. Encurte o texto e tente de novo.",
            invalidIconSvg: "O arquivo enviado não é um SVG válido.",
            iconSvgTooLarge: "O arquivo SVG pode ter até 100 KB.",
            tierOrderMismatch: "A lista de níveis mudou. Recarregue a página para ver a ordem atual.",
            invalidTier: "Um dos níveis escolhidos não existe mais. Recarregue a página e escolha de novo.",
            invalidAutomation: "A lista de automações mudou. Feche e abra a exclusão de novo.",
            pointsProgramInactive: "Ligue o programa de pontos para usar os níveis.",
            automationsPermissionRequired: "Você não tem permissão para pausar automações.",
        },
        panel: {
            close: "Fechar",
            createTitle: "Adicionar nível",
            editTitle: "Alterar nível",
            settings: "Configurar",
            design: "Design",
            name: "Nome do nível",
            namePlaceholder: "Ex: VIP, Ouro, Embaixador...",
            description: "Descrição",
            descriptionPlaceholder: "Breve explicação sobre quem pertence a este nível",
            segment: "Segmento",
            segmentPlaceholder: "Selecione o segmento",
            segmentLoading: "Carregando segmentos...",
            segmentSearch: "Buscar segmento",
            segmentEmpty: "Nenhum segmento encontrado",
            segmentUsedBy: "Usado no nível {name}",
            segmentLoadError: "Não foi possível carregar os segmentos.",
            becoming: "Como se tornar",
            becomingPlaceholder: "Ex: Acumule 10.000 pontos em 12 meses",
            tierRewards: "Recompensas desse nível",
            rewardsEmpty: "Nenhuma recompensa vinculada. Vincule recompensas a este nível na aba Programa de pontos.",
            rewardsHint: "Para vincular ou remover recompensas, edite a recompensa na aba Programa de pontos.",
            tierColor: "Cor do nível",
            textColor: "Cor da fonte",
            iconType: "Ícone",
            iconEmoji: "Emoji",
            iconSvg: "SVG",
            emojiPlaceholder: "Cole um emoji aqui (ex: 👑)",
            emojiInvalid: "Use um emoji.",
            svgUploadTitle: "Escolha um arquivo ou arraste e solte aqui.",
            svgUploadDescription: "Apenas arquivos .svg",
            svgUploadHint: "Use um ícone simples e quadrado, sem texto e sem margem em volta. Ele também aparece pequeno, ao lado do nome do nível.",
            svgUploadButton: "Procurar arquivo",
            svgUploadDelete: "Excluir ícone",
            svgDefaultName: "icone.svg",
            svgInvalid: "Arquivo SVG inválido.",
            preview: "Pré-visualização",
            previewName: "Nome do nível",
            previewDescription: "Descrição do nível",
            delete: "Excluir",
            save: "Criar nível",
            saveChanges: "Alterar nível",
            missingFieldsTooltip: "Preencha os campos obrigatórios: {fields}",
        },
        unsaved: {
            title: "Descartar alterações?",
            description: "As alterações feitas neste nível ainda não foram salvas.",
            keepEditing: "Continuar editando",
            discard: "Descartar",
        },
        deleteModal: {
            title: "Tem certeza?",
            description: "O nível será apagado de vez e não pode ser restaurado. O segmento continua existindo e os resgates já feitos ficam no extrato.",
            impactLoading: "Calculando o que muda com a exclusão...",
            impactError: "Não foi possível calcular o impacto da exclusão. Feche e tente de novo.",
            noImpact: "Nenhuma recompensa ou automação será afetada.",
            deactivateTitle: "Estas recompensas perdem o vínculo e ficam inativas (reative depois, se quiser):",
            unlinkTitle: "Estas recompensas continuam disponíveis nos outros níveis:",
            automationsTitle: "Automações que usam o segmento deste nível",
            automationsHint: "Marque as que você quer pausar junto com a exclusão.",
            automationsNoPermissionHint: "Elas continuam ativas. Para pausar, peça a alguém com permissão de automações.",
            phrase: "EXCLUIR {0} PERMANENTEMENTE",
            cancel: "Cancelar",
            confirm: "Deletar",
        },
        examples: {
            bronze: {
                title: "Bronze",
                description: "Fazem parte do nosso grupo de compradores ativos.",
            },
            silver: {
                title: "Prata",
                description: "Clientes Prata demonstram frequência nas compras e maior engajamento com nosso ecossistema.",
            },
            gold: {
                title: "Ouro",
                description: "Clientes Ouro são altamente engajados e estão entre os que mais aproveitam nosso programa.",
            },
        },
    },
    points: {
        systemLabel: "Programa de pontos",
        pointsFactorLabel: "Quanto o cliente precisa gastar ({currency}) para ganhar 1 ponto?",
        maxPointsPerOrderLabel: "Qual é o limite de pontos por pedido?",
        maxPointsPerOrderPlaceholder: "Sem limite",
        accrualPreview: "{amount} → {points} pontos",
        accrualPreviewCapped: "{amount} → {points} pontos (limite por pedido)",
        title: "Recompensas",
        addReward: "Adicionar recompensa",
        pointsLabel: "pontos",
        deleteModalTitle: "Tem Certeza?",
        deleteModalDescription: "Essa recompensa será removida permanentemente.",
        deleteModalCancel: "Cancelar",
        deleteModalConfirm: "Deletar",
        deactivateModalTitle: "Desativar programa de pontos?",
        deactivateModalDescription: "Ao desativar o programa de pontos, as seguintes automações ativas serão pausadas automaticamente:",
        deactivateModalEmptyDescription: "Tem certeza que deseja desativar o programa de pontos?",
        deactivateModalImpactTitle: "Além disso:",
        deactivateModalImpactSales: "Novas vendas não acumularão mais pontos para os clientes.",
        deactivateModalImpactSegments: "Segmentos que utilizam filtro de saldo de pontos pararão de ser atualizados.",
        deactivateModalImpactRewards: "Os clientes não poderão resgatar recompensas de pontos.",
        deactivateModalConfirm: "Desativar programa",
        emptyTitle: "Crie suas recompensas",
        emptyDescription: "Crie as recompensas do programa de pontos para oferecer aos seus clientes.",
        createFirst: "Criar primeira recompensa",
        panel: {
            createTitle: "Adicionar recompensa",
            editTitle: "Editar recompensa",
            close: "Fechar",
            sectionsLabel: "Seções da recompensa",
            details: "Detalhes",
            rules: "Regras",
            name: "Nome da recompensa",
            namePlaceholder: "Ex: Copo térmico exclusivo",
            subtitle: "Subtítulo",
            subtitlePlaceholder: "Ex: Troque por 500 pontos",
            description: "Descrição",
            descriptionPlaceholder: "Descreva os detalhes da recompensa...",
            image: "Imagem",
            imagePlaceholder: "Selecione uma imagem para esta recompensa",
            points: "Pontos",
            pointsPlaceholder: "Ex: 500",
            privacy: "Privacidade",
            privacyAll: "Mostrar para todos",
            privacyBlurred: "Mostrar ofuscada para todos",
            privacyTierOnly: "Somente para clientes do nível",
            privacySpecific: "Clientes em segmentos específicos",
            startDate: "Data de início",
            endDate: "Data de fim",
            clearDate: "Limpar",
            canUse: "Permitir resgate manual pelo sistema",
            clientCanUse: "Cliente pode usar a recompensa",
            clientCanUseHintOn: "O cliente resgata a recompensa pelo app e os pontos são debitados automaticamente.",
            clientCanUseHintOff: "O cliente só visualiza a recompensa; o resgate precisa ser feito pela equipe no sistema.",
            howToUse: "Como usar a recompensa",
            howToUseInstructions: "Como usar essa recompensa?",
            howToUseInstructionsPlaceholder: "Descreva as instruções de uso...",
            successMessage: "Mensagem de sucesso",
            successMessagePlaceholder: "Escreva o que o cliente verá logo após resgatar a recompensa no app, como uma confirmação ou orientação do próximo passo.",
            usageOption: "Como o cliente usa a recompensa",
            usageOptionRequired: "Marque pelo menos uma das opções acima: sem nenhuma delas o cliente não consegue usar a recompensa nem sabe como usá-la.",
            hasUsageInstructions: "Adicionar instruções de uso",
            usageInstructions: "Instruções de uso",
            usageInstructionsPlaceholder: "Ex: Apresente o código no caixa...",
            cancel: "Fechar",
            save: "Salvar",
            saveChanges: "Salvar alterações",
            delete: "Excluir",
            deleteBlocked: "Não é possível excluir uma recompensa que já foi resgatada.",
            confirmDelete: "Tem certeza que deseja excluir esta recompensa?",
            deleteSuccess: "Recompensa excluída com sucesso!",
            createSuccess: "Recompensa criada com sucesso!",
            editSuccess: "Recompensa salva com sucesso!",
            createError: "Erro ao criar recompensa.",
            editError: "Erro ao atualizar recompensa.",
            createRewardButton: "Criar recompensa",
            imageUploadTitle: "Escolha um arquivo ou arraste e solte aqui.",
            imageUploadDesc: "Use a resolução 1920x1080. Apenas .jpg .png",
            imageUploadButton: "Procurar Arquivo",
            imageUploadDelete: "Excluir imagem",
            missingFieldsTooltip: "Preencha os campos obrigatórios: {fields}",
            tiers: "Níveis",
            tiersPlaceholder: "Todos os clientes",
            tiersDisabledHint: "Os níveis estão desabilitados. A restrição passa a valer quando você habilitar o sistema de níveis.",
        },
        exampleCost: "7 pontos",
        exampleName: "Borda especial",
        exampleSubtitle: "Cupom de R$13,90"
    },
    login: {
        title: "Tela de Login",
        background: "Background",
        solidColor: "Cor sólida",
        image: "Imagem",
        color: "Cor",
        backgroundImageTitle: "Escolha uma imagem ou arraste e solte aqui.",
        backgroundImageDescription: "Use uma imagem em .jpg ou .png",
        backgroundImageButton: "Procurar imagem",
        deleteBackgroundImage: "Excluir imagem de background",
        form: "Formulário",
        firstName: "Nome",
        lastName: "Sobrenome",
        birthDate: "Data de Nascimento",
        email: "Email",
        required: "Obrigatório",
    },
    faq: {
        title: "Perguntas Frequentes",
        addQuestion: "Adicionar pergunta",
        addQuestionTitle: "Adicionar pergunta",
        editQuestion: "Editar pergunta",
        editQuestionTitle: "Editar pergunta",
        deleteQuestion: "Excluir pergunta",
        question: "Pergunta",
        answer: "Resposta",
        questionPlaceholder: "Como resgato meus pontos?",
        answerPlaceholder: "Digite a resposta da pergunta",
        introTitle: "Título da seção",
        introTitlePlaceholder: "Perguntas frequentes",
        introShowTitle: "Exibir o título",
        introImage: "Imagem",
        introShowImage: "Exibir a imagem",
        introImageTitle: "Escolha uma imagem ou arraste e solte aqui.",
        introImageDescription: "Use uma imagem em .jpg ou .png",
        introImageButton: "Procurar imagem",
        introImageDelete: "Excluir imagem do FAQ",
        introText: "Texto de introdução",
        introTextPlaceholder: "Escreva um texto que aparece antes das perguntas",
        introShowText: "Exibir o texto de introdução",
        close: "Fechar",
        saveChanges: "Salvar alterações",
        deleteModalTitle: "Excluir pergunta",
        deleteModalDescription: "Tem certeza que deseja excluir esta pergunta?",
        deleteModalCancel: "Cancelar",
        deleteModalConfirm: "Excluir",
        emptyError: "Preencha a pergunta antes de salvar.",
        saveError: "Ocorreu um erro ao salvar a pergunta.",
        addSuccess: "Pergunta adicionada com sucesso!",
        updateSuccess: "Pergunta atualizada com sucesso!",
        deleteSuccess: "Pergunta removida com sucesso!",
        deleteError: "Ocorreu um erro ao remover a pergunta.",
    },
    terms: {
        title: "Termos de uso",
        settings: "Configurar",
        panelTitle: "Termos de uso",
        bodyPlaceholder: "Digite os termos e condições",
        close: "Fechar",
        saveChanges: "Salvar alterações",
        success: "Termos atualizados com sucesso!",
        error: "Ocorreu um erro ao salvar os termos.",
    },
    banners: {
        title: "Banners",
        count: "Quantidade {0}/{1}",
        dropTitle: "Escolha um arquivo ou arraste e solte aqui.",
        dropDescription: "Use a resolução 1920x1080. Apenas .jpg .png",
        limitReachedTitle: "Limite de banners atingido",
        limitReachedDescription: "Você já adicionou 5 banners. Exclua um banner para adicionar outro.",
        searchFile: "Procurar Arquivo",
        dragHandle: "Reordenar banner",
        addLinkAction: "Adicionar link",
        editLinkAction: "Editar link",
        deleteAction: "Excluir banner",
        linkModalTitle: "Configurar link de direcionamento",
        linkLabel: "Link",
        copyLink: "Copiar Link",
        copyLinkAgain: "Copiar novamente",
        linkCopied: "Copiado",
        linkModalSave: "Salvar",
        deleteModalTitle: "Excluir banner",
        deleteModalDescription: "Tem certeza que deseja excluir este banner?",
        deleteModalCancel: "Cancelar",
        deleteModalConfirm: "Excluir",
        statusCompleted: "Concluído",
        statusUploading: "Enviando..",
        statusError: "Erro no envio",
    },
    colorPicker: {
        title: "Selecione uma cor",
        basics: "Básicas",
        hex: "Hex",
        open: "Abrir seletor de cor",
        saturationBrightness: "Saturação e brilho",
        saturationBrightnessValue: "Saturação {0}%, brilho {1}%",
        hue: "Matiz",
    },
    upload: {
        oversized: "O tamanho máximo por imagem é {0}MB. As seguintes imagens excederam o limite: {1}",
        parseError: "Erro ao interpretar a resposta do servidor.",
        serverError: "Ocorreu um erro no servidor ao tentar enviar as imagens.",
        httpError: "Erro {0} ao realizar o upload.",
        networkError: "Erro de rede. Verifique sua conexão com a internet.",
        success: "Upload realizado com sucesso!",
        deleted: "Imagem removida com sucesso!",
        bannerDeleted: "Banner removido com sucesso!",
        deleteModalTitle: "Remover imagem",
        deleteModalDescription: "Tem certeza que deseja remover esta imagem?",
        uploadError: "Erro ao fazer upload da imagem.",
    },
};
